<mat-accordion>
  <mat-expansion-panel [(expanded)]="expanded" (closed)="onPanelClosed()">
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if ((form.invalid || !canSave) && isSubmitted) {
          <mat-icon class="error-icon"
          matTooltip="Section configuration contains errors">error</mat-icon>
        }
        @if (form.dirty && !expanded) {
          <mat-icon class="warning-icon"
          matTooltip="Section configuration contains unsaved changes">warning</mat-icon>
        }
        <h2>{{sectionName}} @if (sectionConfig.versions?.length) {
          <span>(UI version:
          {{sectionConfig.versions.join(', ')}})</span>
        }</h2>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="form" (ngSubmit)="save()">
      <section-general-configuration [parentFormGroup]="form"
      [sectionConfig]="sectionConfig"></section-general-configuration>
      <data-filtering-configuration [parentFormGroup]="form"
      [sectionConfig]="sectionConfig"></data-filtering-configuration>
      <topbar-filters-configuration [parentFormGroup]="form"
      [sectionConfig]="sectionConfig"></topbar-filters-configuration>
      <search-box-hint-configuration [parentFormGroup]="form"
      [searchBoxHintConfig]="sectionConfig.searchBoxHintConfig"></search-box-hint-configuration>
      <no-data-label-configuration [parentFormGroup]="form"
      [noDataLabelConfig]="sectionConfig.noDataLabelConfig"></no-data-label-configuration>
      <banners-configuration [bannersConfig]="sectionConfig.bannersConfig" [sectionConfigId]="sectionConfig.id"
      [parentFormGroup]="form" [isSubmitted]="isSubmitted"></banners-configuration>
      <app-groups-configuration [parentFormGroup]="form"
      [sectionConfig]="sectionConfig"></app-groups-configuration>
      <div class="controls">
        <div matTooltip="Please select files to upload" [matTooltipDisabled]="canSave">
          <button mat-raised-button color="primary" type="submit" [disabled]="!canSave || isSaving">Save</button>
        </div>
      </div>
    </form>
  </mat-expansion-panel>
</mat-accordion>
